let retries = 0;
export const domain = "https://vehshop.com";
export default {
  async sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    console.log("sleeping...");
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
    console.log("done sleeping!");
  },

  async fetchData(url, user = false) {
    let headers = { "Content-Type": "application/json" };

    if (user) {
      headers["Authorization"] = `Token ${localStorage.getItem("token")}`;
    }

    try {
      let response = await fetch(url, { headers });
      if (response.ok) {
        let data = response.json();
        return data;
      } else {
        console.log("the fetch was not ok", response);
        return false;
      }
    } catch (e) {
      console.log(e);
      this.sleep(5000);
      if (retries < 10) {
        console.log("fetching again");
        return await this.fetchData(url);
      }
    }
  },

  async postData(url, data) {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (localStorage.getItem("token")) {
      headers["Authorization"] = `Token ${localStorage.getItem("token")}`;
    }

    try {
      let response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });

      if (response.ok) {
        let response_data = await response.json();
        return response_data;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }
  },
};
